import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// Fix of JIT compilation faild for KeycloakAuthService Injection
import '@angular/compiler';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

export const getApiUrl = () => {
  return environment.apiEnpoints['administrationApi'];
};

// Todo: Add the other API endpoints
const providers = [{ provide: 'API_URL', useFactory: getApiUrl, deps: [] }];

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(AppModule);
// .catch((err) => console.error(err));
